import { render, staticRenderFns } from "./my-recommend.vue?vue&type=template&id=1fc89fa2&scoped=true&"
import script from "./my-recommend.vue?vue&type=script&lang=js&"
export * from "./my-recommend.vue?vue&type=script&lang=js&"
import style0 from "./my-recommend.vue?vue&type=style&index=0&id=1fc89fa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc89fa2",
  null
  
)

export default component.exports